import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Context } from '..';
import HtmlMessage from './HtmlMessage';


const MessageItem = observer(({ msgId, idx, isMine }) => {
  const { chat } = useContext(Context);

  const msg = chat.messages.find(m => m.id === msgId);
  
  if (!msg) return null;

  const isSystem = msg.type === 'system';
  const isDeleted = msg.isDeleted;
  const isEdited = msg.isEdited;

  if (isSystem || isDeleted) {
    return (
      <div key={msg.id || idx} style={{
        textAlign: 'center',
        color: '#999',
        fontSize: '12px',
        margin: '10px 0',
        fontStyle: 'italic',
        animation: 'messageAppear 0.3s ease-out'
      }}>
        {msg.text}
      </div>
    );
  }

  return (
    <>
      <style>{`
        @keyframes messageAppear {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .message-bubble {
          transition: transform 0.15s ease, box-shadow 0.15s ease;
        }
        .message-bubble:hover {
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(0,0,0,0.15);
        }
      `}</style>
      
      <div
        key={msg.id || idx}
        style={{
          display: 'flex',
          justifyContent: isMine ? 'flex-end' : 'flex-start',
          marginBottom: '8px',
          position: 'relative',
          animation: 'messageAppear 0.3s ease-out'
        }}
        className="message-row"
      >
        {/* === БЛОК СООБЩЕНИЯ — контекстное меню здесь === */}
        <div
          className="message-bubble"  // ✅ ДОБАВЛЕН КЛАСС
          style={{
            maxWidth: '70%',
            padding: '8px 12px',
            borderRadius: '12px',
            background: isMine ? '#3390ec' : 'white',
            color: isMine ? 'white' : 'black',
            boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
            position: 'relative',
            cursor: 'context-menu'
          }}
          onDoubleClick={() => {
            chat.setReplyingTo(msg);
          }}
          onContextMenu={(e) => {
            e.preventDefault();
            e.stopPropagation();
            chat.showContextMenu(e.clientX, e.clientY, msg);
          }}
        >
          {/* Имя отправителя для чужих сообщений */}
          {!isMine && msg.sender && (
            <div style={{
              fontSize: '11px',
              fontWeight: 'bold',
              color: '#3390ec',
              marginBottom: '2px'
            }}>
              {msg.sender?.persons_info?.name || 
               msg.sender?.email || 'Пользователь'}
            </div>
          )}
          
          {/* Цитата ответа */}
          {msg.parentMessage && (
            <div style={{
              padding: '6px 10px',
              background: isMine ? 'rgba(255,255,255,0.2)' : '#f0f0f0',
              borderRadius: '6px',
              marginBottom: '6px',
              borderLeft: `2px solid ${isMine ? 'rgba(255,255,255,0.5)' : '#3390ec'}`,
              fontSize: '12px',
              cursor: 'pointer'
            }}>
              <div style={{ 
                fontWeight: 'bold', 
                color: isMine ? 'rgba(255,255,255,0.9)' : '#3390ec',
                marginBottom: '2px'
              }}>
                {msg.parentMessage.sender?.persons_info?.name || 'Пользователь'}
              </div>
              <div style={{ 
                color: isMine ? 'rgba(255,255,255,0.8)' : '#666',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}>
                {msg.parentMessage.text?.substring(0, 50)}
              </div>
            </div>
          )}
          
          {/* Текст сообщения */}
          <HtmlMessage text={msg.text} isHtml={msg.isHtml} />
          
          {/* Время и статус */}
          <div style={{
            fontSize: '10px',
            opacity: 0.7,
            marginTop: '4px',
            textAlign: 'right',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '4px'
          }}>
            {isEdited && <span style={{ fontSize: '9px' }}>(изменено)</span>}
            <span>
              {new Date(msg.createdAt).toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit'
              })}
            </span>
            {isMine && msg.id && !msg.id.startsWith('temp_') && chat.shouldShowStatus(msg.id) && (
              <span 
                style={{ 
                  marginLeft: '4px',
                  fontSize: '14px',
                  lineHeight: 1,
                  color: chat.getMessageStatus(msg.id) === 'read' ? '#4fc3f7' : 'rgba(255,255,255,0.9)',
                  fontWeight: 'bold',
                  letterSpacing: '-2px'
                }}
              >
                {chat.getMessageStatus(msg.id) === 'read' ? '✓✓' :
                chat.getMessageStatus(msg.id) === 'delivered' ? '✓✓' :
                '✓'}
              </span>
            )}
          </div>

          {/* === РЕАКЦИИ — ВНУТРИ блока сообщения, внизу === */}
          {msg.reactions && msg.reactions.length > 0 && (
            <div style={{
              display: 'flex',
              gap: '4px',
              marginTop: '6px',
              paddingTop: '6px',
              borderTop: `1px solid ${isMine ? 'rgba(255,255,255,0.2)' : '#f0f0f0'}`,
              flexWrap: 'wrap'
            }}>
              {Object.entries(
                msg.reactions.reduce((acc, r) => {
                  if (!acc[r.emoji]) acc[r.emoji] = [];
                  acc[r.emoji].push(r);
                  return acc;
                }, {})
              ).map(([emoji, reactions]) => {
                const hasMyReaction = reactions.some(r => r.userId === chat.currentUserId);
                
                const tooltipText = reactions.map(r => {
                  const name = r.user?.persons_info?.name || r.user?.name || r.user?.email || 'Пользователь';
                  const surname = r.user?.persons_info?.surname || r.user?.surname || '';
                  return `${name} ${surname}`.trim();
                }).join(', ');
                
                return (
                  <button
                    key={emoji}
                    className="reaction-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      chat.toggleReaction(msg.id, emoji);
                    }}
                    style={{
                      background: hasMyReaction 
                        ? (isMine ? 'rgba(255,255,255,0.25)' : '#e3f2fd') 
                        : (isMine ? 'rgba(255,255,255,0.1)' : '#f4f4f5'),
                      border: hasMyReaction 
                        ? '1px solid rgba(255,255,255,0.4)' 
                        : (isMine ? '1px solid rgba(255,255,255,0.2)' : '1px solid #e4e4e5'),
                      borderRadius: '12px',
                      padding: '2px 6px',
                      cursor: 'pointer',
                      fontSize: '13px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '3px',
                      transition: 'all 0.2s',
                      whiteSpace: 'nowrap'
                    }}
                    title={tooltipText}
                    onMouseEnter={(e) => {
                      if (!hasMyReaction) {
                        e.currentTarget.style.background = isMine ? 'rgba(255,255,255,0.2)' : '#e4e4e5';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!hasMyReaction) {
                        e.currentTarget.style.background = isMine ? 'rgba(255,255,255,0.1)' : '#f4f4f5';
                      }
                    }}
                  >
                    <span>{emoji}</span>
                    <span style={{ 
                      fontSize: '11px', 
                      color: isMine ? 'rgba(255,255,255,0.8)' : '#707579' 
                    }}>
                      {reactions.length}
                    </span>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
});

export default MessageItem;